<template>
  <div class="wrapper">
    <side-bar>

      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link v-for="(route, index) in routes[0].children" v-if="route.meta.display"
                    :to="route.path"
                    :key="route.path"
                    :class="{'sidebar-menu-item': route.children.length}">
        <i class="nc-icon" :class="route.icon" ></i>
        <p>{{route.name}}</p>
        <span v-if="route.children.length && route.meta.childDisplay">
          <i class="fas fa-caret-down float-right m-0"></i>
          <i class="fas fa-caret-right float-right m-0"></i>
        </span>
        <ul class="nav" v-if="route.children.length && route.meta.childDisplay">
          <sidebar-link v-for="(cRoute, index) in route.children" v-if="cRoute.meta.display"
                        :to="cRoute.path"
                        :key="cRoute.path">
            <p>{{cRoute.name}}</p>
          </sidebar-link>
        </ul>

      </sidebar-link>

    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import routes from '../../../routes/routes'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data() {
      return {
        routes: routes
      }
    },
    created() {
      // `this` points to the vm instance
      this.routes = this.routes.filter(item => item.children);
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue